const doc = [({"da":({"js":({"admin":({"navigations":({"show":({"navigation":"Navigation", "open_in_google_maps":"Åbn i Google Maps"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;